import { createReducer, on } from '@ngrx/store';
import { CardTransaction } from 'src/app/models/card-transaction.model';
import { Card } from 'src/app/models/card.model';
import * as fromCardsActions from '../../actions/cards/cards.actions';
import { TransactionHistoryList } from './../../../models/transaction-history.model';

export const cardsFeatureKey = 'cards';

export interface State {
  selectedCard: Card | null;
  transactionHistory: CardTransaction | null;
  transactionHistoryList: TransactionHistoryList | null;
}

export const initialState: State = {
  selectedCard: null,
  transactionHistoryList: null,
  transactionHistory: null
};

export const reducer = createReducer(
  initialState,
  on(
    fromCardsActions.layoutSelectActiveCard,
    fromCardsActions.cardsComponentSelectActiveCard,
    (state, action) => {
      return {
        ...state,
        selectedCard: action.selectedCard
      };
    }
  ),
  on(fromCardsActions.loadTransactionHistorySuccess, (state, action) => {
    return {
      ...state,
      transactionHistory: action.cardTransactions
    };
  }),

  on(fromCardsActions.setCardTransactionDetails, (state, action) => {
    return {
      ...state,
      transactionHistoryList: action.cardTransactionDetails
    };
  })
);
